import { render, staticRenderFns } from "./APIPagination.vue?vue&type=template&id=385ac409&"
import script from "./APIPagination.vue?vue&type=script&lang=ts&"
export * from "./APIPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports